export default __webpack_public_path__ + "static/media/teacher1.69a348aa.png";